export default [
 {
  id: 1,
  github: "https://github.com/pezzonovante7/sudoku",
  description: "The model takes the image of an unsolved sudoku as an input. The sudoku puzzle is extracted from the image using opencv library functions. The retreived sudoku is solved by using simple backtracking algorithm.",
  title: "Sudoku Solver using OpenCV",
  stack: [
   {
    id: 1,
    title: "python"
   },
   {
    id: 2,
    title: "opencv"
   },
   {
    id: 3,
    title: "keras"
   }
  ]
 },
 {
  id: 2,
  github: "https://github.com/pezzonovante7/task-manager",
  description: "A productivity web application for managing different activities using javascript. The application utilized the functionality of javascript lists for managing the tasks.",
  title: "Task Manager",
  stack: [
   {
    id: 1,
    title: "HTML"
   },
   {
    id: 2,
    title: "CSS"
   },
   {
    id: 3,
    title: "JavaScript"
   }
  ]
 },
 {
  id: 3,
  github: "https://github.com/pezzonovante7/auto-suggest",
  description: "A data structure based application for searching different words in a dictionary in a relatively lower asymptotic time complexity. Trie data structure is used for optimizing the search complexity of the algorithm.",
  title: "Auto Suggest using tries",
  stack: [
   {
    id: 1,
    title: "c++"
   },
   {
    id: 2,
    title: "data-structure"
   },
  ]
 },
]